import type Swiper from 'swiper';
import { loadHighResImage, loadLowResImage, progressivelyLoadImages } from './load-images';

const handleRealIndexChange = (swiper: Swiper): void => {
    if (swiper.activeIndex === 1 && !swiper.el.dataset.lowResImagesLoaded) {
        const skipNumOfSlides = 1;
        const range = {
            start: swiper.activeIndex + skipNumOfSlides,
            end: swiper.slides.length
        };
        progressivelyLoadImages(swiper, range, loadLowResImage);
        swiper.el.dataset.lowResImagesLoaded = 'true';
    }

    const additionalSlidesToLoad = 3;
    const highResRange = {
        start: swiper.activeIndex,
        end: Math.min(swiper.activeIndex + additionalSlidesToLoad, swiper.slides.length)
    };

    progressivelyLoadImages(swiper, highResRange, loadHighResImage);
};

export default handleRealIndexChange;
